<template lang="html">
  <v-dialog
    v-model="SuccessDialog"
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card :style="stylechat">
      <v-card-title primary-title style="justify-content: center;">
        {{SuccessDialogDetail.title}}
      </v-card-title>
      <v-card-text style="text-align: center;">
        <span class="fontsize-span">{{SuccessDialogDetail.text}}</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row justify="center" align="center">
          <v-col cols="6" align="center">
            <v-btn class="btn-color-confirm" block text @click="closeDialog()">{{$t('AnswerQuestion.ok')}}</v-btn>
          </v-col>
          <!-- <v-divider vertical class="mt-1"></v-divider>
          <v-col cols="6" align="center">
            <v-btn class="btn-color-cancel" block text @click="closeDialog()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          </v-col> -->
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    SuccessDialog: Boolean,
    SuccessDialogDetail: {}
  },
  data () {
    return {
      tokenbot: '',
      password: '',
      stylechat: {
        "--SuccessDialog-HeaderColor": "white",
        "--SuccessDialog-TabBackground": "white",
        "--SuccessDialog-Icon": "gray",
        "--SuccessDialog-IconActive": "#2662ae",
        "--SuccessDialog-Background": "white",
        "--SuccessDialog-FontSize": "18px",
        "--SuccessDialog-FontColor": "black",
        "--SuccessDialog-FontSize-Status": "16px",
        "--SuccessDialog-FontSize-Text": "17px",
        "--SuccessDialog-Color-Text": "#727272",
        "--SuccessDialog-FontColor-Status": "grey",
        "--SuccessDialog-Background-Input": "#E2E1E3",
        "--SuccessDialog-Color-Button": "#EFF2FE",
        "--SuccessDialog-FontColor-Button": "#2662ae",
        "--SuccessDialog-FontColor-Button-Cancel": "#cb1002"
      },
    }
  },
  watch: {
    SuccessDialog () {
      // console.log(this.SuccessDialog)
      // console.log(this.SuccessDialogDetail)
      if (this.SuccessDialog) {
        // this.tokenbot = this.SuccessDialogDetail.user.tokenuser
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeAlertDialog', { type: 'success', value: false })
    },
    // confirmData () {
    //   this.$emit('emitWarning', this.SuccessDialogDetail)
    // }
  }
}
</script>

<style lang="css" scoped>
.fontsize-span {
  font-size: var(--SuccessDialog-FontSize-Text) !important;
  color: var(--SuccessDialog-Color-Text) !important;
}
.btn-color-confirm {
  color: var(--SuccessDialog-FontColor-Button) !important;
  text-transform: none !important;
  font-weight: 600;
  font-size: var(--SuccessDialog-FontSize) !important;
}
.btn-color-cancel {
  color: var(--SuccessDialog-FontColor-Button-Cancel) !important;
  text-transform: none !important;
  font-size: var(--SuccessDialog-FontSize) !important;
}
>>>.v-dialog {
  border-radius: 15px;
  margin: 24px;
  overflow: hidden;
  pointer-events: auto;
  width: 100%;
  z-index: inherit;
  outline: none;
}
>>>.v-input__slot {
  background-color: var(--SuccessDialog-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
</style>
